import type { NotificationConfig } from './types';

export const notificationConfigs: NotificationConfig[] = [
  {
    id: 'order-payment',
    name: '订单支付通知',
    category: 'system',
    enabled: true,
    channels: ['sms', 'email', 'insite'],
    rule: '用户完成订单支付时触发',
    smsTemplateId: 'SMS_123456789',
    emailTemplate: {
      name: 'order-payment-template.html',
      url: 'https://example.com/templates/order-payment.html'
    },
    insiteTemplate: '您的订单已支付成功，订单号：{orderNo}，支付金额：{amount}元。'
  },
  {
    id: 'refund-complete',
    name: '退款完成通知',
    category: 'system',
    enabled: true,
    channels: ['sms', 'email', 'insite'],
    rule: '用户订单退款完成时触发',
    smsTemplateId: 'SMS_987654321',
    emailTemplate: {
      name: 'refund-complete-template.html',
      url: 'https://example.com/templates/refund-complete.html'
    },
    insiteTemplate: '您的退款已处理完成，订单号：{orderNo}，退款金额：{amount}元，预计3-5个工作日到账。'
  },
  {
    id: 'cloud-pc-expiry',
    name: '云电脑到期提醒',
    category: 'system',
    enabled: true,
    channels: ['sms', 'email', 'insite'],
    rule: '用户云电脑到期提前X天时触发',
    customValue: 3,
    smsTemplateId: 'SMS_111222333',
    emailTemplate: {
      name: 'cloud-pc-expiry-template.html',
      url: 'https://example.com/templates/cloud-pc-expiry.html'
    },
    insiteTemplate: '您的云电脑"{cloudPcName}"将在{days}天后到期，请及时续费以免影响使用。'
  },
  {
    id: 'cloud-pc-release-warning',
    name: '云电脑释放提醒',
    category: 'system',
    enabled: true,
    channels: ['sms', 'insite'],
    rule: '用户云电脑即将释放前X天时触发',
    customValue: 7,
    smsTemplateId: 'SMS_444555666',
    insiteTemplate: '您的云电脑"{cloudPcName}"将在{days}天后被释放，请及时续费以保留数据。'
  },
  {
    id: 'cloud-pc-released',
    name: '云电脑释放通知',
    category: 'system',
    enabled: false,
    channels: ['email', 'insite'],
    rule: '用户云电脑被释放时触发通知',
    emailTemplate: {
      name: 'cloud-pc-released-template.html',
      url: 'https://example.com/templates/cloud-pc-released.html'
    },
    insiteTemplate: '您的云电脑"{cloudPcName}"已被释放，如需继续使用请重新购买。'
  },
  {
    id: 'verification-code',
    name: '注册/登录验证码',
    category: 'verification',
    enabled: true,
    channels: ['sms', 'email'],
    rule: '用户主动获取登录/注册验证码时触发',
    smsTemplateId: 'SMS_777888999',
    emailTemplate: {
      name: 'verification-code-template.html',
      url: 'https://example.com/templates/verification-code.html'
    }
  },
  {
    id: 'balance-low',
    name: '余额不足提醒',
    category: 'marketing',
    enabled: true,
    channels: ['sms', 'email', 'insite'],
    rule: '用户账户余额不足X元时触发',
    customValue: 50,
    smsTemplateId: 'SMS_101112131',
    emailTemplate: {
      name: 'balance-low-template.html',
      url: 'https://example.com/templates/balance-low.html'
    },
    insiteTemplate: '您的账户余额不足{amount}元，当前余额：{balance}元，请及时充值以免影响服务使用。'
  },
  {
    id: 'points-low',
    name: '积分不足提醒',
    category: 'marketing',
    enabled: true,
    channels: ['sms', 'insite'],
    rule: '用户账户积分不足X元时触发',
    customValue: 100,
    smsTemplateId: 'SMS_141516171',
    insiteTemplate: '您的账户积分不足{amount}分，当前积分：{points}分，请及时充值以免影响服务使用。'
  },
  {
    id: 'storage-low',
    name: '云存储不足提醒',
    category: 'marketing',
    enabled: false,
    channels: ['email', 'insite'],
    rule: '用户云电脑云存储占用超过 X% 时触发',
    customValue: 80,
    emailTemplate: {
      name: 'storage-low-template.html',
      url: 'https://example.com/templates/storage-low.html'
    },
    insiteTemplate: '您的云存储使用率已达{percent}%，剩余空间：{freeSpace}GB，建议及时清理或扩容。'
  },
  {
    id: 'inactive-user',
    name: '长期未登录唤醒通知',
    category: 'marketing',
    enabled: true,
    channels: ['sms', 'email', 'insite'],
    rule: '用户账户超过 X 天未登录时触发',
    customValue: 30,
    smsTemplateId: 'SMS_181920212',
    emailTemplate: {
      name: 'inactive-user-template.html',
      url: 'https://example.com/templates/inactive-user.html'
    },
    insiteTemplate: '您已{days}天未登录，我们为您准备了专属优惠，快来看看吧！'
  }
];
